var accomodationView = {
	selectors: {
		buttons: ".js-accomodation-view-buttons",
		info_name: ".js-accomodation-view-info-name",
		info_price: ".js-accomodation-view-info-price",
		input: ".js-accomodation-view-input",
		mapItem: '.accomodation-main__map__preview'
	},

	init: function () {
		const self = this;

		self.load();
		self.mapItem();
	},

	mapItem: function() {
		const self = this;

		if( jQuery( self.selectors.mapItem ).length == 0 ) {
			return false;
		}

		const customSVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" color="#f1c062" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.6893 22.6825L11.6894 22.6826L11.6949 22.6851C11.8888 22.7713 12.1107 22.7715 12.3046 22.6854L12.3083 22.6837L12.3085 22.6836C12.3312 22.6732 12.3869 22.6477 12.4203 22.632C12.4913 22.5986 12.5934 22.5496 12.7221 22.4853C12.9794 22.3566 13.3438 22.1663 13.7797 21.9161C14.6496 21.4166 15.813 20.6738 16.9801 19.7012C19.2892 17.7769 21.75 14.8358 21.75 11C21.75 5.61522 17.3848 1.25 12 1.25C6.61522 1.25 2.25 5.61522 2.25 11C2.25 14.8358 4.71077 17.7769 7.01986 19.7012C8.18703 20.6738 9.35038 21.4166 10.2203 21.9161C10.6562 22.1663 11.0206 22.3566 11.2779 22.4853C11.4034 22.548 11.613 22.6466 11.6893 22.6825ZM12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15C14.2091 15 16 13.2091 16 11C16 8.79086 14.2091 7 12 7Z" fill="currentColor" /></svg>`;

		// Create a custom divIcon using the SVG
		const svgIcon = L.divIcon({
			html: customSVG,            // Insert the SVG code here
			className: 'custom-svg-icon',
			iconSize: [48, 48],         // Size matches the SVG width/height
			iconAnchor: [24, 48],       // Position the "tip" of the icon at bottom center
			popupAnchor: [0, -48]       // Optional: position popups
		});

		const defaultLat = jQuery( self.selectors.mapItem ).attr( 'data-lat' );
		const defaultLng = jQuery( self.selectors.mapItem ).attr( 'data-lng' );
		const defaultZoom = 13;

		// Create the map
		const map = L.map('map').setView([defaultLat, defaultLng], defaultZoom);

		// Add OpenStreetMap tiles
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			maxZoom: 19,
		}).addTo(map);

		// Place a marker at the specified coordinates
		L.marker([defaultLat, defaultLng], { icon: svgIcon }).addTo(map).bindPopup( jQuery( 'h1' ).text() ).openPopup();
	},

	load: function () {
		const self = this;

		if (jQuery(self.selectors.buttons).length === 0) {
			return; //exit not found
		}

		jQuery(self.selectors.buttons).children("a").on("click", function (event) {
			event.preventDefault();

			jQuery(self.selectors.buttons).children("a").removeClass("active");
			jQuery(this).addClass("active");

			jQuery(self.selectors.input).val(jQuery(this).data("id"));

			self.reCalc();
		});

		//init select the first item
		jQuery(self.selectors.buttons).children("a").eq(0).trigger("click");
	},

	reCalc: function () {
		const self = this;

		const name = jQuery(self.selectors.buttons).children("a.active").find(".name").text();
		const price = jQuery(self.selectors.buttons).children("a.active").find(".price").text();

		jQuery(self.selectors.info_name).html(name);
		jQuery(self.selectors.info_price).html(price);
	},
}

// Export
export { accomodationView };